module.exports = __webpack_public_path__ + "media/images/icons/user_plus-ee17a3562cb3438856df0a18b30e7428.svg";